import { createAuthClient } from 'better-auth/react'
import { API_BASE_URL } from './config'

// Points at the ADMIN Better Auth instance, which is entirely separate from the
// customer one at /api/auth. Its cookies use the 'cbb-admin' prefix, so signing
// in here never disturbs a customer session in the same browser.
//
// Must be absolute: Better Auth validates this with `new URL()` and throws
// "Invalid base URL" on a relative path. The customer app avoids that by
// omitting baseURL when the API is same-origin, but that fallback resolves to
// the default /api/auth basePath — which is the wrong instance for us. So when
// API_BASE_URL is empty (the normal case: Vite proxies in dev, server.mjs
// proxies in production) the current origin is filled in explicitly.
const origin = typeof window === 'undefined' ? '' : window.location.origin

export const authClient = createAuthClient({
	baseURL: `${API_BASE_URL || origin}/api/admin/auth`,
	fetchOptions: { credentials: 'include' },
})

export const { signIn, signOut, useSession } = authClient
